export const getQueryString = (params: object): string => {
    const queryParams: string[] = [];
    Object.entries(params).forEach(([key, value]) => {
        if (key === "url") {
            return;
        }
        queryParams.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParams.length > 0 ? queryParams.join("&") : "";
};

// @ts-expect-error Check for typing
export const getQueryParameter = (name: string, url = window.top.location.href): string | null => {
    name = name.replace(/[[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!Array.isArray(results)) {
        return null;
    }
    if (typeof results[2] !== "string") {
        return "";
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const getRandomString = (size: number = 45): string => {
    const unreserved = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    let randomString = "";
    const crypto = window.crypto;
    if (crypto) {
        const bytes: Uint8Array = new Uint8Array(size);
        crypto.getRandomValues(bytes);
        const numbers: number[] = [];
        bytes.forEach((x, i) => {
            numbers[i] = unreserved.charCodeAt(x % unreserved.length);
        });
        randomString = String.fromCharCode.apply(null, numbers);
    } else {
        while (0 < size--) {
            randomString +=
                // eslint-disable-next-line no-bitwise
                unreserved[Math.floor(Math.random() * unreserved.length) | 0];
        }
    }
    return randomString;
};

export const createHash = (str: string): string => {
    let hash = 0;
    let chr: number;
    if (str.length > 0) {
        for (let i = 0; i < str.length; i++) {
            chr = str.charCodeAt(i);
            // eslint-disable-next-line no-bitwise
            hash = (hash << 5) - hash + chr;
            // eslint-disable-next-line no-bitwise
            hash |= 0;
        }
    }
    return String(hash);
};

const strToBuffer = (str: string): Uint8Array => {
    const arrayBuffer = new ArrayBuffer(str.length);
    const uintArray = new Uint8Array(arrayBuffer);
    uintArray.forEach((_, i) => {
        uintArray[i] = str.charCodeAt(i);
    });
    return uintArray;
};

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const base64UrlEncode = (str: any): string => {
    return window.btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
};

export const getCodeVerifier = (): string => {
    return base64UrlEncode(getRandomString(43));
};

export const getCodeChallenge = async (codeVerifier: string): Promise<string> => {
    try {
        const digest: ArrayBuffer = await crypto.subtle.digest("SHA-256", strToBuffer(codeVerifier));
        const digestBase64 = String.fromCharCode(...Array.from(new Uint8Array(digest)));
        return base64UrlEncode(digestBase64);
    } catch {
        return codeVerifier;
    }
};

export const getUrlOrigin = (url: string): string => {
    const regex = new RegExp("^(https?:\\/\\/[^\\/?]+)");
    const results = regex.exec(url);
    if (!Array.isArray(results)) {
        return "";
    }
    return results[1];
};

const CHECK_SESSION_IFRAME_TPL = `
<script type="text/javascript">
    /** @type {HTMLIFrameElement} */
    var opIframe = document.createElement("iframe");

    /** @type {number} */
    var pollIntervalDelay = 2000;

    /** @type {number} */
    var pollInterval;

    /**
     * Send poll message to OP iframe
     */
    function poll () {
        try {
            opIframe.contentWindow.postMessage("{CLIENT_ID} {SESSION_STATE}", "{OP_ORIGIN}");
        } catch (e) {
            console.error(e);
            window.clearInterval(pollInterval);
        }
    }

    /**
     * Pass OP iframe message up to host
     * @param event {MessageEvent}
     */
    function receiveMessage(event) {
        window.parent.postMessage([event.data, "{SESSION_STATE}"].join(" "), "{ORIGIN}");
    }

    window.onload = function() {
        opIframe.src = "{OP_SRC}";
        document.body.appendChild(opIframe);
        window.addEventListener("message", receiveMessage);
        pollInterval = window.setInterval(poll, pollIntervalDelay);
    }
</script>
`;

interface CheckSessionIframeParams {
    session_state: string;
    client_id: string;
    op_src: string;
}

export const getCheckSessionIframeSrcdoc = ({ session_state, client_id, op_src }: CheckSessionIframeParams): string => {
    return CHECK_SESSION_IFRAME_TPL.replace(/{CLIENT_ID}/g, client_id)
        .replace(/{SESSION_STATE}/g, session_state)
        .replace(/{OP_ORIGIN}/g, getUrlOrigin(op_src))
        .replace(/{OP_SRC}/g, op_src)
        .replace(/{ORIGIN}/g, window.origin);
};
